import { Component, ElementRef, OnInit, inject, viewChild, signal, ViewEncapsulation } from "@angular/core";
import { OrdersService } from '../../services/orders.service';
import { UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';

import { Blog } from '../../models/blog';
import { Category } from '../../models/category';
import { UntypedFormControl } from '@angular/forms';
import { CategoryService } from '../../services/categories.service';
import { ConfirmationService, MessageService, SelectItem, PrimeTemplate } from "primeng/api";
import * as moment from 'moment';
import { TYPE_LIST } from '../../constants/constants';
import { Clients } from 'src/app/models/clients';
import { ClientsService } from 'src/app/services/clients.service';
import { Location, CurrencyPipe } from '@angular/common';
import { WorksService } from 'src/app/services/works.service';
import { Works } from 'src/app/models/works';
import { Locations } from 'src/app/models/locations';
import { Bookings } from 'src/app/models/bookings';
import { Employees } from 'src/app/models/employees';
import { BookingsService } from 'src/app/services/bookings.service';
import { LocationsService } from 'src/app/services/locations.service';
import { EmployeesService } from 'src/app/services/employees.service';
import { CompanyService } from 'src/app/services/company.service';
import { Company } from 'src/app/models/company';
declare var jsPDF: any;

import "jspdf-autotable";
import { Billings } from 'src/app/models/billings';
import { map, tap } from 'rxjs/operators';
import { ISkill } from 'src/app/models/rooms';
import { BillingsService } from 'src/app/services/billings.service';
import { CdkDragDrop, moveItemInArray, CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';

import { formatDate } from "@angular/common";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Bind } from 'primeng/bind';
import { ButtonDirective } from 'primeng/button';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primeng/tabs';
import { Ripple } from 'primeng/ripple';
import { DatePicker } from 'primeng/datepicker';
import { Select } from 'primeng/select';
import { Textarea } from 'primeng/textarea';
import { Card } from 'primeng/card';
import { Tag } from 'primeng/tag';
import { InputText } from 'primeng/inputtext';
import { InputNumber } from 'primeng/inputnumber';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';
import { TranslatePipe } from '@ngx-translate/core';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
    standalone: true,
    selector: "app-documents-form",
    templateUrl: "./documents-form.component.html",
    styleUrl: "./documents-form.component.less",
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, ReactiveFormsModule, Bind, ButtonDirective, RouterLink, Tabs, TabList, Ripple, Tab, TabPanels, TabPanel, DatePicker, Select, PrimeTemplate, Textarea, Card, Tag, CdkDropList, CdkDrag, InputText, InputNumber, ConfirmDialog, Toast, CurrencyPipe, TranslatePipe]
})
export class DocumentsFormComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private ordersService = inject(OrdersService);
  private messageService = inject(MessageService);
  private clientsService = inject(ClientsService);
  private _location = inject(Location);
  private locationsService = inject(LocationsService);
  private worksService = inject(WorksService);
  private employeesService = inject(EmployeesService);
  private companyService = inject(CompanyService);
  private billingsService = inject(BillingsService);
  private categoryService = inject(CategoryService);
  private confirmationService = inject(ConfirmationService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  readonly myInputVariable = viewChild<ElementRef>("myInput");

  readonly pageTitle = signal<string>(undefined);
  readonly error = signal<string>(undefined);
  readonly uploadError = signal<string>(undefined);
  readonly imagePath = signal<any>(undefined);
  blogs: Blog;
  blog: Blog;
  blogForm: UntypedFormGroup;
  itemTotal: any
  bookings: Bookings;
  booking: Bookings;
  billing: Billings;
  billings: Billings;
  readonly pages = signal<any>(undefined);
  categories: any = [];
  category: Category;
  readonly works = signal<any>([]);
  work: Works;
  checked: boolean = true;
  selectedValue: string;
  readonly typeList = signal<any[]>(undefined);
  readonly clients = signal<any>([]);
  client: Clients;
  arrString: string;
  employees: any = [];
  employee: Employees;
  skillsArray: any = [];
  description: any;
  readonly selectedWorks = signal<SelectItem[]>([]);
  selectedWorks2: SelectItem[];
  locations: any = [];
  location: Locations;
  readonly subTotal = signal<any>(undefined);
  readonly vat = signal<any>(undefined);
  readonly grandTotal = signal<any>(undefined);
  cities: Blog[];
  format1: string = "";
  format2: string = "";
  selectedCity: Blog;
  selectedCategories: Category;
  selectedClients: Clients;
  readonly selectedDate = signal<Date>(undefined);
  date: Date;
  works_id: any;
  readonly page = signal<string>(undefined);
  readonly idOrders = signal<string>(undefined);
  readonly categoryOrders = signal<string>(undefined);
  readonly works_idOrders = signal<any>(undefined);
  readonly company = signal<Company>(undefined);
  readonly descriptionOrders = signal<string>(undefined);
  readonly dateOrders = signal<any>(undefined);
  readonly numberOrders = signal<string>(undefined);
  readonly currentUser = signal<any>(undefined);
  public dataValues: object;
  addForm: UntypedFormGroup;
  rows: UntypedFormArray;
  itemForm: UntypedFormGroup;
  skillsForm: UntypedFormGroup;
  readonly skillsValues = signal<any>([]);
  total: number;
  viewMode = '1';
  readonly fiscaltype = signal<number>(undefined);
  readonly editForm = signal<boolean>(true);
  readonly numberQuotes = signal<string>(undefined);
  readonly dateBookings = signal<string>(undefined);
  readonly categoryBookings = signal<string>(undefined);
  readonly descriptionBillings = signal<string>(undefined);
  additionalDetails: string;
  readonly idBilling = signal<string>(undefined);
  contactNo: number;

  trackByFn(index, item) {
    return item.id;
  }

  constructor() {
    if (this.date) {
      this.selectedDate.set(new Date(this.date));
    }
    this.currentUser.set(JSON.parse(localStorage.getItem('currentUser') || '[]'));

    this.typeList.set(TYPE_LIST);
    this.fiscaltype.set(0);

  }
  readonly reportContent = viewChild<ElementRef>('reportContent');

  ngOnInit() {

    this.currentUser.set(JSON.parse(localStorage.getItem('currentUser') || '[]'));
    const userId = this.currentUser().user_id;
    this.page.set(history.state);

    this.getselectedWorks;

    this.worksService.getAllListbyUser().subscribe(
      (data: Works) => (this.works.set(data)),
      (error) => (this.error.set(error))
    );

    this.clientsService.getAllListbyUser().subscribe(
      (data: Clients) => (this.clients.set(data)),
      (error) => (this.error.set(error))
    );

    this.companyService.getId(userId).subscribe(
      (data: Company) => (this.company.set(data)),
      (error) => (this.error.set(error))
    );

    this.companyService.getId(userId).subscribe(value => {
      this.fiscaltype.set(this.company().fiscaltype);
    });

    const id = this.route.snapshot.paramMap.get("id");

    this.ordersService.skills(id).subscribe(value => {
      this.skillsValues.set(value);
    });

    this.billingsService
    .find_billings_by_order_id(id)
    .subscribe(data => {
      this.pages.set(data[0]);
      return data.id;
    }, err => {
  });

    if (id) {
      this.pageTitle.set("Modifica Ordine");
      this.ordersService.getId(id).subscribe((res) => {
        this.imagePath.set(res.image);
        this.idOrders.set(res.id);
        this.categoryOrders.set(res.category_id);
        this.descriptionOrders.set(res.description);
        this.dateOrders.set(res.date);
        this.grandTotal.set(res.total);
        this.vat.set(res.vat);
        this.subTotal.set(res.subtotal);
        this.numberOrders.set(res.order_id);
        this.works_idOrders.set(res.works_id.split(','));
        this.numberQuotes.set(res.quotes_id);
        this.dateBookings.set(res.date);
        this.categoryBookings.set(res.category_id);
        this.descriptionBillings.set(res.description);
        this.idBilling.set(res.id);

        this.blogForm.patchValue({
          title: res.title,
          description: res.description.split(','),
          category_id: res.category_id,
          order_id: res.order_id,
          works_id: res.works_id.split(','),
          user_id: this.currentUser().user_id,
          is_featured: res.is_featured,
          date: res.date,
          id: res.id,
          skills: this.skillsValues(),
          subtotal: res.subtotal,
          vat: res.vat,
          total: res.total,

        });

      });
    } else {
      this.pageTitle.set("Aggiungi Ordine");
    }

    this.blogForm = this.fb.group({
      id: [""],
      title: [""],
      description: [""],
      order_id: [""],
      category_id: [""],
      works_id: [""],
      user_id: [this.currentUser().user_id],
      is_featured: ["0"],
      date: ["", Validators.required],
      skills: this.initSkill(this.skillsValues()),
      subtotal: [""],
      vat: [""],
      total: [this.grandTotal()],
    });
  }

  readonly content = viewChild<ElementRef>('content');

  drop(event: CdkDragDrop<string[]>) {
    const id = this.route.snapshot.paramMap.get("id");
    moveItemInArray(this.skillsValues(), event.previousIndex, event.currentIndex);
    this.updateSkills(event, id);

  }

  updateSkills(event, id) {
    const formData = new FormData();
    formData.append('skills', JSON.stringify(this.skillsValues()));

    this.ordersService.update_skills(formData, id).subscribe({
      next: (response: any) => {
        if (response.error) {
        } else {
          this.messageService.add({key: 'myKey1', severity:'success', summary: 'Conferma', detail: 'Salvato con successo'});
          this.initSkill(this.skillsValues());
          this.blogForm.patchValue({
            skills: this.skillsValues(),
          })

        }
      },
    });
  }

  public downloadPDF() {
    const doc = new jsPDF();
    const specialElementHandlers = {
      '#editor': function (element, renderer) {
        return true;
      }
    };

    const content = this.reportContent().nativeElement;

    doc.fromHTML(content.innerHTML, 15, 15, {
      'width': 190,
      'elementHandlers': specialElementHandlers
    });

    doc.save('Fattura-' + this.idOrders() + '.pdf');

  }

  getselectedWorks() {
    this.selectedWorks.set(this.works_id.split(','));
    }

  changed(value){
      this.descriptionOrders.set(value.target.value)
    }

  changeTime(value){
      this.dateOrders.set(new Date());
    }

  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.blogForm.get("image").setValue(file);

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (_event) => {
        this.imagePath.set(reader.result);
      };
    }
  }

  getCategoryItem(categoryBookings: string, id: string) {
    return this.clients().find((item) => item.id === categoryBookings);
  }

  editFormItems() {
    this.editForm.set(! this.editForm());

  }

  getWorksItem(works_id: string, id: string) {
    return this.works().find(item => item.id === works_id);
  }

  removeImageFile() {
    this.imagePath.set("");
    const myInputVariable = this.myInputVariable();
    console.log(myInputVariable.nativeElement.files);
    myInputVariable.nativeElement.value = "";
    console.log(myInputVariable.nativeElement.files);
  }

  get title() {
    return this.blogForm.get("title");
  }

  initSkill(skillsValues: ISkill[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    const id = this.route.snapshot.paramMap.get("id");

    this.ordersService.skills(id).subscribe(
      (res)=>{
        this.skillsValues.set(res);

        this.skillsValues().forEach((e)=>{
          formArray.push(this.fb.group({
            description: e.description,
            qty: e.qty,
            price: e.price,
            itemTotal: e.qty * e.price,
          }))
        })
      }
    )

    return formArray;
  }

  private createSkillFormGroup(skill:any): UntypedFormGroup{
    return new UntypedFormGroup({
      'qty':new UntypedFormControl(skill.qty),
      'price':new UntypedFormControl(skill.price),
      'itemTotal':new UntypedFormControl(skill.itemTotal)
    })
  }

  public addSkill(skill:any){
    this.skills.push(this.createSkillFormGroup(skill));
  }

  get skills() {
    return this.blogForm.get('skills') as UntypedFormArray;
  }

  itemsChanged(): void {
    let total: number = 0;
    for (let t = 0; t < (<UntypedFormArray>this.blogForm.get('skills')).length; t++) {
      if (this.blogForm.get('skills')?.value[t].qty != '' && this.blogForm.get('skills')?.value[t].price) {
        total = (this.blogForm.get('skills')?.value[t].qty * this.blogForm.get('skills')?.value[t].price) + total;
      }
    }
    this.subTotal.set(total);
    this.vat.set(this.subTotal() / 100 * this.company().fiscaltype);
    this.grandTotal.set(this.subTotal() + this.vat());

  }

  newQuantity(): UntypedFormGroup {
    const numberPatern = '^[0-9.,]+$';
    return this.fb.group({
      description: [''],
      qty: [1, [Validators.required, Validators.pattern(numberPatern)]],
      price: ['', [Validators.required, Validators.pattern(numberPatern)]],
      itemTotal: [''],

    })
  }

  addQuantity(event) {
    this.skills.push(this.newQuantity());
  }

  removeQuantity(i: number): void {
    let totalCostOfItem = this.blogForm.get('skills')?.value[i].qty * this.blogForm.get('skills')?.value[i].price;
    this.subTotal.set(this.subTotal() - totalCostOfItem);
    this.vat.set(this.subTotal() / 100 * this.company().fiscaltype);
    this.grandTotal.set(this.subTotal() + this.vat());
    (<UntypedFormArray>this.blogForm.get('skills')).removeAt(i);
  }

  get total_sum() {
    return this.itemTotal.reduce((total, fee) => total + fee.balance, 0);
}

generatePDF(action = 'open') {
  const format = 'dd/MM/yyyy';
  const formatYear = 'yyyy';

  const locale = 'en-US';

  const formattedDate = formatDate(this.dateBookings(), format, locale);
  const formattedDateYear = formatDate(this.dateBookings(), formatYear, locale);

  let docDefinition = {
    layout: 'headerLineOnly',

    content: [

      {
        "canvas": [{
          "lineColor": "gray",
          "type": "line",
          "x1": 0,
          "y1": 0,
          "x2": 515,
          "y2": 0,
          "lineWidth": 1
        }]
      },

      {
        text: '' + this.company().name + '',
        fontSize: 12,
        alignment: 'left',
        margin: [0, 20 ,0, 0],

        bold: true,

        color: '#111'
      },
      {
        text: '' + this.company().address + ' ' + this.company().zip + ' ' + this.company().city + '',
        fontSize: 12,
        alignment: 'left',
        color: '#111'
      },
      {
        text: '' + this.company().fiscalcode + ' ' + this.company().fiscalnumber + '',
        fontSize: 12,
        alignment: 'left',
        color: '#111'
      },
      {
        text: 'Cliente',
        bold: true,
        margin: [0, 20 ,0, 0],

      },
      {

        columns: [
          [
            {
              text: this.getCategoryItem(this.categoryBookings(), '222')?.username},
            { text: this.getCategoryItem(this.categoryBookings(), '222')?.address },
            { text: this.getCategoryItem(this.categoryBookings(), '222')?.zip + ' ' + this.getCategoryItem(this.categoryBookings(), '222')?.city },
            { text: this.getCategoryItem(this.categoryBookings(), '222')?.fiscalcode + ' ' + this.getCategoryItem(this.categoryBookings(), '222')?.fiscalnumber },
            { text: this.contactNo }
          ],
          [
            {
              text: 'Data: '+ formattedDate +'',
              alignment: 'right',

            },
            {
              text: 'Numero Ordine: ' + this.idBilling() + '/'+ formattedDateYear + '',
              bold: true,
              alignment: 'right',

            }
          ]
        ]
      },

      {
        text: 'Note',
        bold: true,
        margin: [0, 20 ,0, 0],

      },
      {
        text: this.descriptionBillings(),
        fontSize: 12,
      },
      {
        text: 'Dettagli Ordine',
        style: 'sectionHeader'
      },

      { layout: 'lightHorizontalLines',
        table: {
          headerRows: 1,

          widths: ['*', 'auto', 'auto', 'auto'],
          body: [
            ['Posizione', 'Qty', 'Prezzo', 'Totale'],
            ...this.skillsValues().map(p => ([p.description, p.qty, p.price, (p.price*p.qty).toFixed(2)])),
            [{text: 'Totale senza Iva', colSpan: 3}, {}, {}, (Math.round(this.subTotal() * 100) / 100).toFixed(2)],
            [{text: 'Iva (' + this.company().fiscaltype + '%)', colSpan: 3}, {}, {}, (Math.round(this.vat() * 100) / 100).toFixed(2)],
            [{bold: true, fontSize: 14, text: 'Totale', colSpan: 3}, {}, {}, (Math.round(this.grandTotal() * 100) / 100).toFixed(2)]
          ]
        }
      },
      {
          text: this.additionalDetails,
          margin: [0, 0 ,0, 25]
      },

      {
        "canvas": [{
          "lineColor": "gray",
          "type": "line",
          "x1": 0,
          "y1": 0,
          "x2": 200,
          "y2": 0,
          "lineWidth": 1
        }]
      },

      {
        columns: [

          [{ text: 'Firma',
          alignment: 'left',
          italics: false,
          margin: [0, 5 ,15, 0]
        }],
        ]
      },
      {
        text: 'Condizioni',
        fontSize: 12,
        bold: true,
        margin: [0, 25 ,15, 0]

      },
      {
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam',
          fontSize: 9,

      }
    ],
    styles: {
      sectionHeader: {
        bold: true,
        decoration: 'underline',
        fontSize: 14,
        margin: [0, 15,0, 15]
      }
    }
  };

  if(action==='download'){
    pdfMake.createPdf(docDefinition).download('Ordine-' + this.idBilling() + '.pdf');
  }else if(action === 'print'){
    pdfMake.createPdf(docDefinition).print();
  }else{
    pdfMake.createPdf(docDefinition).open();
  }

}

createBilling() {
  const formData = new FormData();

  formData.append("title", this.blogForm.get("title").value);
  formData.append("description", this.blogForm.get("description").value);
  formData.append("order_id",  this.blogForm.get("id").value);
  formData.append("category_id", this.blogForm.get("category_id").value);
  formData.append("is_featured", this.blogForm.get("is_featured").value);
  formData.append("works_id", this.blogForm.get("works_id").value);
  formData.append("date", this.blogForm.get("date").value);
  formData.append('user_id', this.blogForm.get('user_id').value);
  formData.append('skills', JSON.stringify(this.blogForm.get('skills').value));
  formData.append('subtotal', this.subTotal());
  formData.append('vat', this.vat());
  formData.append('total', this.grandTotal());

  const id = this.blogForm.get("id").value;
  this.billingsService
      .find_billings_by_order_id(id)
      .subscribe(data => {
        this.pages.set(data[0]);
        return data.id;
        console.log(data[0])
      }, err => {
    });

  if (id ) {
    this.confirmationService.confirm({
      message: 'Vorresti creare la Fattura ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.billingsService.create(formData).subscribe(
          (res) => {
            if (res.status === "error") {
              this.uploadError.set(res.message);
            } else {
              const currentUrl = this.router.url;

              this.messageService.add({ key: 'myKey1', severity: 'info', summary: 'Attenzione', detail: 'Futtura / Ricevuta creata con successo' });
              this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
                this.router.navigate([currentUrl]);

            });
            }
          },
          error => this.error.set(error)
        );
      },
    });
  } else {
    this.router.navigate(['/admin/billings/edit/', this.pages().id]);
  }
}

  onSubmit() {
    const formData = new FormData();
    formData.append("title", this.blogForm.get("title").value);
    formData.append("description", this.blogForm.get("description").value);
    formData.append("appointment_id", this.blogForm.get("id").value);
    formData.append("category_id", this.blogForm.get("category_id").value);
    formData.append("is_featured", this.blogForm.get("is_featured").value);
    formData.append("works_id", this.blogForm.get("works_id").value);
    formData.append("date", this.blogForm.get("date").value);
    formData.append('user_id', this.blogForm.get('user_id').value);
    formData.append('skills', JSON.stringify(this.blogForm.get('skills').value));
    formData.append('subtotal', this.subTotal());
    formData.append('vat', this.vat());
    formData.append('total', this.grandTotal());

    const id = this.blogForm.get("id").value;

    if (id) {
      this.ordersService.update(formData, id).subscribe(
        (res) => {
          if (res.status == "error") {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Attenzione', detail: 'Salvato con sucesso' });
            this.ngOnInit();

          }
        },
        (error) => (this.error.set(error))
      );
    } else {
      this.ordersService.create(formData).subscribe(
        (res) => {
          if (res.status === "error") {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Attenzione', detail: 'Salvato con sucesso' });
            this._location.back();
          }
        },
        (error) => (this.error.set(error))
      );
    }
  }
}
